import * as yup from 'yup'


export const RestPassVal = yup.object().shape({
    email: yup.string().email().required('email is a required field'),
    
})